// dwaar/src/App.jsx
// Repo: terralekha-core | Folder: dwaar/src/
// Dwaar — root component. Routes:
//   /login             → Aavahan  (invitation / magic-link request)
//   /auth/callback     → Saakshi  (witness / magic-link verifier)
//   /dashboard         → Kendra   (hub / authenticated dashboard) — guarded by Dvarapal
//   /passport/new      → Srishti  (creation / new PassPort form)  — guarded by Dvarapal
//   /passport/:id      → Samiksha (review / PassPort detail + confirmation) — guarded by Dvarapal
//   /supervisor        → Niriksha (control centre — admin role only) — guarded by Dvarapal
//   *                  → redirect to /login

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Aavahan  from "./pages/Aavahan.jsx";
import Saakshi  from "./pages/Saakshi.jsx";
import Kendra   from "./pages/Kendra.jsx";
import Srishti  from "./pages/Srishti.jsx";
import Samiksha from "./pages/Samiksha.jsx";
import Niriksha from "./pages/Niriksha.jsx";
import Satyapan from "./pages/Satyapan.jsx";
import Dvarapal from "./components/Dvarapal.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/login"         element={<Aavahan />} />
      <Route path="/auth/callback" element={<Saakshi />} />
      <Route
        path="/dashboard"
        element={
          <Dvarapal>
            <Kendra />
          </Dvarapal>
        }
      />
      <Route
        path="/passport/new"
        element={
          <Dvarapal>
            <Srishti />
          </Dvarapal>
        }
      />
      <Route
        path="/passport/:id"
        element={
          <Dvarapal>
            <Samiksha />
          </Dvarapal>
        }
      />
      <Route
        path="/supervisor"
        element={
          <Dvarapal requiredRole="admin">
            <Niriksha />
          </Dvarapal>
        }
      />
      <Route
        path="/audit"
        element={
          <Dvarapal requiredRole="auditor">
            <Satyapan />
          </Dvarapal>
        }
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
